import { useContext } from 'react'
import { DialogContext } from 'context/dialog'

const useDialog = () => useContext(DialogContext)

export default useDialog
